import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_POS_OPTIONS_API, GET_POS_PRODUCTS_SKU_API, GET_POS_MEMBER_INFO_API, POST_POS_ORDER_API, POST_POS_ITEMS_CAMPAIGN_API } from "@apis/apiPath";

const usePosApi = () => {
	const Ajax = useAjax();

	// 取得POS系統選項 - 集中式選項管理
	const getPosOptionsApi = useCallback(
		async () => {
			return await Ajax.get(GET_POS_OPTIONS_API);
		},
		// eslint-disable-next-line
		[],
	);

	// 取得POS商品SKU資訊
	const getPosProductsSkuApi = useCallback(
		async skuNo => {
			return await Ajax.get(GET_POS_PRODUCTS_SKU_API, { skuNo });
		},
		// eslint-disable-next-line
		[],
	);

	// 取得POS會員資訊
	const getPosMemberInfoApi = useCallback(
		async codeNo => {
			return await Ajax.get(GET_POS_MEMBER_INFO_API, { codeNo });
		},
		// eslint-disable-next-line
		[],
	);

	// 建立POS訂單
	const postPosOrderApi = useCallback(
		async params => {
			return await Ajax.post(POST_POS_ORDER_API, params);
		},
		// eslint-disable-next-line
		[],
	);

    const postPosItemsCampaignApi = useCallback(
        async params => {
            return await Ajax.post(POST_POS_ITEMS_CAMPAIGN_API, params);
        },
        // eslint-disable-next-line
        [],
    );

	return {
		getPosOptionsApi,
		getPosProductsSkuApi,
		getPosMemberInfoApi,
		postPosOrderApi,
        postPosItemsCampaignApi,
	};
};

export default usePosApi;
